import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [token, setToken] = useState("");
  const [show, setShow] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.post(
        "https://365luxuryhomes.com/api/admin/login",
        { username, password }
      );

      localStorage.setItem("authToken", response.data.token);
      setToken(response.data.token);
      navigate("/");
      setError("");
    } catch (err) {
      setError("Invalid username or password");
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-base-200 p-4">
      <div className="w-full max-w-md">
        <div className="admin-card">
          <h1 className="admin-page-title mb-2">Admin Login</h1>
          <p className="admin-page-desc mb-6">Sign in to the dashboard</p>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="admin-label">Username</label>
              <input
                type="text"
                value={username}
                className="input input-bordered w-full rounded-admin"
                onChange={(e) => setUsername(e.target.value)}
              />
            </div>
            <div className="relative">
              <label className="admin-label">Password</label>
              <input
                type={show ? "text" : "password"}
                value={password}
                className="input input-bordered w-full rounded-admin pr-10"
                onChange={(e) => setPassword(e.target.value)}
              />
              <button
                type="button"
                onClick={() => setShow(!show)}
                className="absolute right-3 top-9 text-base-content/50 hover:text-base-content p-1 rounded-admin"
                aria-label={show ? "Hide password" : "Show password"}
              >
                {!show ? (
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={20} height={20} fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round">
                    <path d="M2 8C2 8 6.47715 3 12 3C17.5228 3 22 8 22 8" />
                    <path d="M21.544 13.045C21.848 13.4713 22 13.6845 22 14C22 14.3155 21.848 14.5287 21.544 14.955C20.1779 16.8706 16.6892 21 12 21C7.31078 21 3.8221 16.8706 2.45604 14.955C2.15201 14.5287 2 14.3155 2 14C2 13.6845 2.15201 13.4713 2.45604 13.045C3.8221 11.1294 7.31078 7 12 7C16.6892 7 20.1779 11.1294 21.544 13.045Z" />
                    <path d="M15 14C15 12.3431 13.6569 11 12 11C10.3431 11 9 12.3431 9 14C9 15.6569 10.3431 17 12 17C13.6569 17 15 15.6569 15 14Z" />
                  </svg>
                ) : (
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={20} height={20} fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M22 8C22 8 18 14 12 14C6 14 2 8 2 8" />
                    <path d="M15 13.5L16.5 16" />
                    <path d="M20 11L22 13" />
                    <path d="M2 13L4 11" />
                    <path d="M9 13.5L7.5 16" />
                  </svg>
                )}
              </button>
            </div>

            {error && (
              <p className="text-error text-sm">{error}</p>
            )}

            <button type="submit" className="btn btn-primary w-full rounded-admin">
              Login
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
